import React, { useCallback, useMemo } from "react";
import { useWidgetCategories } from "./Categories/useWidgetCategories";
import { WACategoryKey } from "./WANavigation";
import { WidgetAddMasterComponent } from "./WidgetAddMasterComponent";

export function WidgetAddMaster(props: {
  selected?: WACategoryKey;
  chevron?: boolean;
  onPressIn?(key: WACategoryKey): void;
  onPress(
    input:
      | { key: Exclude<WACategoryKey, "WACategoryDefaultTodoCategory"> }
      | { key: "WACategoryDefaultTodoCategory"; categoryId: string }
  ): void;
}) {
  const widget = useWidgetCategories();
  const sections = useMemo(
    () =>
      widget.categories.map((a) => ({
        data: a,
      })),
    [widget.categories]
  );

  const onPress = useCallback(
    (key: WACategoryKey) => {
      if (key === "WACategoryDefaultTodoCategory") {
        if (widget.defaultTodoCategoryId) {
          props.onPress({ key, categoryId: widget.defaultTodoCategoryId });
        }
      } else {
        props.onPress({ key });
      }
    },
    [widget.defaultTodoCategoryId, props]
  );

  return (
    <WidgetAddMasterComponent
      chevron={props.chevron}
      selected={props.selected}
      onPressIn={props.onPressIn}
      onPress={onPress}
      sections={sections}
    />
  );
}
